/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */

import React, { Component } from 'react';
import moment from 'moment';
import {
   
    Button,
    
} from 'carbon-components-react';


export default class InspectionWeekHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };


    }


    render() {
        //cella con numero settimana e giorni della settimana 
        return (
            <>

                {this.props.numberweekstart != null ?
                    <div className={this.props.selected ? "box-month-layout color-box-selected" : "box-month-layout color-box"}>
                        <div className="numeric-box-text">
                            {this.props.numberweek}
                        </div>
                        <div className="numeric-box-info">
                            {moment.utc(this.props.numberweekstart).format('DD/MM')}
                        </div>
                        <div className="numeric-box-info">
                            {moment.utc(this.props.numberweekend).format('DD/MM')}
                        </div>
                    </div>
                    :
                    <div className="box-month-layout color-box">
                        <div className="numeric-box-text">
                            
                        </div>
                        <div className="numeric-box-info">
                            
                        </div>
                        <div className="numeric-box-info">
                            
                        </div>
                    </div>
                }
            </>
        );
    }
}
